<template>
  <v-list-item
    v-if="hasContent"
    :class="{ 'notification-unread': !notification.read_at }"
    @click="handleClick"
    two-line
    class="notification-item"
  >
    <!-- Avatar area (can be icon or user image in future) -->
    <v-list-item-avatar>
      <v-avatar color="white" class="elevation-1">
        <v-icon :color="iconColor" size="28">{{ iconName }}</v-icon>
      </v-avatar>
    </v-list-item-avatar>

    <!-- Content -->
    <v-list-item-content>
      <div class="notification-text">
        <span class="title-text">{{ notification.title }}</span>
        <span v-if="notification.body"> {{ notification.body }}</span>
      </div>
      <div class="timestamp">{{ timeAgo(notification.created_at) }}</div>
    </v-list-item-content>

    <!-- Action menu -->
    <v-list-item-action class="d-flex flex-column justify-center align-end">
      <!-- Blue dot for unread -->
      <div v-if="!notification.read_at" class="unread-dot mb-1"></div>

      <!-- More options menu -->
      <v-menu v-model="menuOpen" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item 
            :disabled="!!(notification.read_at || notification.data.message.mandatory)"
            @click.stop="markRead"
          >
            <v-list-item-icon><v-icon>mdi-check</v-icon></v-list-item-icon>
            <v-list-item-title>Mark as read</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="deleteNotification">
            <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NotificationListItem',
  props: {
    notification: Object,
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    hasContent() {
      return this.notification?.title && this.notification?.body;
    },
    iconName() {
      const type = this.notification?.notification_type;
      const map = {
        redirect: 'mdi-link',
        message: 'mdi-magnify',
        maintenance: 'mdi-bell',
        default: 'mdi-bell',
        // Not delete for future ref in case needed
        //   popup: 'mdi-magnify',
        //   email: 'mdi-email',
        //   sms: 'mdi-message'
      };
      return map[type] || map.default;
    },
    iconColor() {
      const map = {
        info: '#2196f3',
        warning: '#fb8c00',
        error: '#e53935',
        success: '#43a047',
        default: '#1976d2',
      };
      return map[this.notification?.style] || map.default;
    },
  },
  methods: {
    handleClick() {
      this.$emit('clicked', this.notification);
    },
    markRead() {
      this.$emit('mark-read', this.notification);
      this.menuOpen = false;
    },
    deleteNotification() {
      this.$emit('delete', this.notification);
    },
    timeAgo(date) {
      return date ? moment(date).fromNow() : '';
    },
  },
};
</script>

<style scoped>
.notification-text {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}
.notification-text .title-text {
  font-weight: 600;
}
.notification-item {
  transition: background-color 0.3s;
}
.notification-item:hover {
  background-color: #f0f2f5;
}
.notification-unread {
  background-color: #e9f2ff;
}
.title-text {
  font-weight: 600;
}
.timestamp {
  font-size: 11px;
  color: #999;
}
.unread-dot {
  width: 10px;
  height: 10px;
  background-color: #1976d2;
  border-radius: 50%;
}

</style>
